<template>
  <el-dialog :title="getTitle"
             :visible.sync="showModal"
             @close="handleCancel"
             :close-on-click-modal="false"
             width="40%">
    <el-col :span="24">
      <el-form :model="roomInfo"
               :rules="roomRules"
               ref="roomForm"
               label-width="130px"
               class="room-form">
        <el-form-item label="人员机构名称："
                      prop="name">
          <el-input v-model.trim="roomInfo.name"
                    placeholder="请输入人员机构名称"></el-input>
        </el-form-item>
        <el-form-item label="所属父级："
                      prop="parent_id">
          <el-select filterable
                     v-model="roomInfo.parent_id"
                     placeholder="请选择所属父级">
            <el-option v-if="hasRoot || roomInfo.parent_id === '0'"
                       label="无"
                       value="0"></el-option>
            <el-option v-for="item in roomList"
                       :key="item.id"
                       :disabled="data.id === item.id"
                       :label="item.name"
                       :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="机构编号："
                      prop="code">
          <el-input v-model.trim="roomInfo.code"
                    placeholder="请输入机构编号"></el-input>
        </el-form-item>
        <!-- <el-form-item label="排序："
                      prop="sort">
          <el-input v-model.trim="roomInfo.sort"
                    placeholder="请输入人员机构排序"></el-input>
        </el-form-item> -->
      </el-form>
    </el-col>
    <span slot="footer"
          class="dialog-footer">
      <el-button @click="handleCancel">取 消</el-button>
      <el-button v-has="'/department/edit' || '/department/add'"
                 type="primary"
                 @click="handleConfirm('roomForm')">
        确 定
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import fetch from '@/common/api'
export default {
  props: {
    isShow: {
      type: Boolean
    },
    data: {
      type: Object
    }
  },
  data() {
    return {
      showModal: this.isShow,
      roomInfo: {
        name: '',
        parent_id: '',
        code: ''
        // sort: ''
      },
      roomRules: {
        name: [{ required: true, message: '请输入人员机构名称' }],
        parent_id: [{ required: true, message: '请选择人员机构类型' }]
      },
      roomList: [],
      tmpArr: []
    }
  },
  computed: {
    getTitle() {
      return this.data.type === 'add' ? '添加人员机构' : '编辑人员机构'
    },
    hasRoot() {
      let ids = this.tmpArr.map((item) => {
        return item.parent_id
      })
      return ids.indexOf('0') < 0
    }
  },
  created() {
    this.getList()
    if (this.data.type === 'edit') {
      this.getInfo()
    }
    if (this.data.id) {
      this.roomInfo.parent_id = this.data.id
    }
  },
  methods: {
    // 获取编辑信息
    getInfo() {
      fetch.getDepartmentInfo({ id: this.data.id }).then((data) => {
        data.procData(
          data.res,
          (data) => {
            this.roomInfo = data
          },
          (err) => {
            this.$message.error(err)
          }
        )
      })
    },
    // 获取数据
    getList() {
      fetch.getDepartmentTreeManage({}).then((data) => {
        data.procData(
          data.res,
          (data) => {
            this.roomList = this.titleFormat(data.treeData, '• ')
          },
          (err) => {
            this.$message.error(err)
          }
        )
      })
    },
    handleConfirm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.data.type === 'add') {
            fetch.addDepartment({ ...this.roomInfo }).then((data) => {
              data.procData(
                data.res,
                () => {
                  this.$message.success('操作成功')
                  this.handleCancel('refresh')
                },
                (err) => {
                  this.$message.error(err)
                }
              )
            })
          } else {
            fetch.editDepartment({ ...this.roomInfo }).then((data) => {
              data.procData(
                data.res,
                () => {
                  this.$message.success('操作成功')
                  this.handleCancel('refresh')
                },
                (err) => {
                  this.$message.error(err)
                }
              )
            })
          }
        } else {
          return false
        }
      })
    },
    handleCancel(type) {
      this.$emit('handleClose', type)
    },
    //  格式化名称
    titleFormat(data, prefix) {
      if (data.length === 0) {
        return []
      }
      data.forEach((item) => {
        let tmp = item
        tmp.name = prefix + item.name
        this.tmpArr.push(tmp)
        if (item.children && item.children.length > 0) {
          this.titleFormat(item.children, '• ' + prefix)
        }
      })
      return this.tmpArr
    }
  }
}
</script>

<style></style>
